<template>
  <b-col md="12" xl="6">
    <section class="hotel">
      <div class="hotel__head">
        <div class="hotel__element">
          <div class="hotel__item">
            <b-form-rating
              class="hotel__star"
              v-if="hotel.rating.stars !== 0"
              no-border inline readonly
              size="sm"
              variant="secondary"
              :value="hotel.rating.stars"
            />
          </div>
          <div class="hotel__item">
            <vb-icon
              class="hotel__icon hotel__icon--like"
              v-if="hotel.rating.preferred"
              :name="'like'"
              :color="sass('secondary')"
              :size="16"
            />
            <p class="hotel__name" v-html="hotel.name.it" />
          </div>
          <div class="hotel__item">
            <vb-icon class="hotel__icon hotel__icon--geo mr-1" :name="'pin'" :color="sass('primary')" :size="12" />
            <span>{{ hotel.location.address.it + ', ' + hotel.location.postal_code + ' ' + hotel.location.city_name }}</span>
          </div>
        </div>
        <div class="hotel__element">
          <score class="hotel__score" :rating="hotel.rating.review_score" />
        </div>
      </div>
      <ul class="hotel__facilities">
        <template v-for="(facility, facility_index) in hotel.facilities">
          <li class="hotel__facilities-li" v-if="facility_index < 8" :key="_uid + '_facility_' + facility_index">
            <facility :item="facility" />
          </li>
        </template>
      </ul>
    </section>
  </b-col>
</template>

<script>
import Score from "@bookingv3/components/atoms/score"
import Facility from "@bookingv3/components/blocks/facility"

export default {
  inheritAttrs: false,
  name: 'hotel',

  components: {
    'facility': Facility,
    'score': Score,
  },

  props: {
    hotel: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .hotel {
    background-color: $white;
    border-radius: 10px;
    padding: 20px;
    height: 100%;

    &__icon {

      &--like {
        margin-right: 5px;
      }
    }

    &__head {
      display: flex;
    }

    &__element {
      &:first-child {
        flex-basis: 100%;
      }
    }

    &__item {
      display: flex;
      align-items: center;
    }

    &__category {
      color: $gray-600;
      font-size: $font-size-md;
    }

    &__star {
      width: auto;
    }

    &__name {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-lg;
      margin-bottom: 0;
    }

    &__facilities {
      border-top: 1px solid $gray-200;
      margin-top: $grid-gutter-width/2;
      margin-bottom: 0;
      padding: $grid-gutter-width/2 0 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;

      &-li {
        display: flex;
        align-items: center;
        font-size: $font-size-md;
        line-height: normal;
        padding: 2px 15px 2px 0;
      }

      ::v-deep {
        .facility-item__icon {
          margin-right: 5px;
        }
      }
    }

    &__score {
      font-size: $font-size-md;

      ::v-deep {
        .score__number {
          span {
            $size: $grid-gutter-width;
            width: $size;
            height: $size;
          }
        }
      }
    }
  }

</style>